import React from "react";
import styled from "styled-components";
import copyIcon from "../../assets/svgs/copy.svg";
import clockIcon from "../../assets/svgs/clock.svg";
import expiredClock from "../../assets/svgs/red-clock.svg";
import { formatTime } from "../../utils/formatTime.js";
import { ContentsContainer } from "../card/cardcontainer.jsx";
import styles from "./bankTransfer.module.css";

// Pure presentation: bank/account/timer display + expiry state.
// The confirm/simulate action goes in via `children`.
export const TransferAccountCard = ({
  amount,
  accountDetails,
  isExpired,
  time,
  onCopy,
  banner,
  children,
}) => (
  <ContentsContainer>
    <div className={styles.cardcontainer}>
      {banner}
      <TextPrompt>
        <p className="text-prompt">
          Transfer {amount ? `NGN ${amount}.00` : ""} to account details below
        </p>
      </TextPrompt>
      <TransferContainer>
        {accountDetails && (
          <>
            <InfoValue>
              <p className="transfer-title"> Bank Name</p>
              <p className="transfer-value">{accountDetails.bankName}</p>
            </InfoValue>
            <InfoValue>
              <p className="transfer-title"> Account Number</p>
              <p className="transfer-value transfer-account">
                {accountDetails.accountNo}{" "}
                <button className="copy-btn" onClick={onCopy}>
                  <img
                    src={copyIcon}
                    alt="copy"
                    className="copy-icon"
                    title="copy"
                    style={{ marginLeft: "10px", height: "30px" }}
                  />
                </button>
              </p>
            </InfoValue>
            <InfoValue>
              <p className="transfer-title"> Account Name</p>
              <p className="transfer-value">{accountDetails.accountName}</p>
            </InfoValue>
          </>
        )}

        {isExpired && (
          <p className="expired-text">
            <img
              src={expiredClock}
              alt="clock"
              className="clock-icon"
              title="clock"
              style={{ marginRight: "10px", height: "20px" }}
            />
            Expired
          </p>
        )}

        {!isExpired && (
          <TextPrompt style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            <p className="text-prompt">
              <img
                src={clockIcon}
                alt="clock"
                className="clock-icon"
                title="clock"
                style={{ marginRight: "10px" }}
              />
              Expires in: {formatTime(time)}
            </p>
          </TextPrompt>
        )}

        {children}
      </TransferContainer>
    </div>
  </ContentsContainer>
);

const TextPrompt = styled.div`
  padding: 10px;
  margin: 0 10px;
  display: flex;
  border-radius: 8px;
  justify-content: center;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  .text-prompt {
    font-weight: 700;
  }
`;

const TransferContainer = styled.div`
  width: 100%;
  border-radius: 8px;
  margin-top: 0.5rem;
  .expired-text {
    color: #9e0a05;
    display: flex;
    justify-content: center;
    border-radius: 20px;
    background-color: #fbeae9;
    width: 150px;
    padding: 10px;
    margin: 16px auto;
  }
`;

const InfoValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
  .copy-btn {
    background-color: transparent;
    border: transparent;
  }
  .copy-icon:hover {
    cursor: pointer;
  }
  .transfer-value {
    font-weight: 700;
    display: flex;
    align-items: center;
    margin: 5px 0;
  }
  .transfer-account {
    font-size: 20px;
  }
`;

export const SubmitBtn = styled.button`
  border: transparent;
  background-color: #e85c2a;
  border-radius: 8px;
  padding: 20px 20px;
  margin: 0 10px;
  box-sizing: border-box;
  width: 95%;
  color: white;
  &[disabled] {
    cursor: not-allowed !important;
    background: #d0d5dd;
  }
`;